var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgParkWhite = function SvgParkWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M19.362 9.365V21M3.814 18.18V21m8.426-2.82V21m-1.056-7.37v2.287M4.63 13.63v2.287M19.362 4.5c1.733 0 3.138 1.421 3.138 3.174v3.513c0 1.754-1.405 3.175-3.138 3.175s-3.137-1.421-3.137-3.174V7.674c0-1.753 1.404-3.174 3.137-3.174ZM2.914 11.572h10.095v2.003H2.914zm-.45 4.376h11.003c.528 0 .963.44.963.974v1.242H1.5v-1.242c0-.534.435-.974.963-.974Z"
  })));
};
export default SvgParkWhite;